import { useQuery } from "@tanstack/react-query";
import { SUPABASE_FUNCTIONS_URL, SUPABASE_ANON_KEY } from "@/lib/supabase";

interface NextCodeResponse {
  next_code: string;
  current_max: number;
}

async function fetchNextCode(isInternal: boolean): Promise<string> {
  const url = `${SUPABASE_FUNCTIONS_URL}/next-project-code${isInternal ? "?internal=true" : ""}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, apikey: SUPABASE_ANON_KEY },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data: NextCodeResponse = await res.json();
  return data.next_code ?? "";
}

/**
 * Predikert neste prosjektkode. Visning, ikke autoritativ — den ekte koden
 * tildeles atomisk på server-siden i create-project (med retry på unique-
 * collision), så samtidige opprettelser kan ikke kollidere.
 */
export function useNextProjectCode(isInternal: boolean = false) {
  const { data, isLoading } = useQuery({
    queryKey: ["next-project-code", isInternal],
    queryFn: () => fetchNextCode(isInternal),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { code: data ?? "", loading: isLoading };
}
